import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const summaryCardStyle = {
  flex: 1,
  minWidth: 180,
  background: "#f8fafc",
  borderRadius: 12,
  padding: 20,
};

const AddSchools = () => {
  const navigate = useNavigate();
  const [schools, setSchools] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [tab, setTab] = useState("table");
  const [search, setSearch] = useState("");
  const [showAddSchool, setShowAddSchool] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [totalStudents, setTotalStudents] = useState(0);

  const fetchSchoolsAndStudents = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_API_URL || "";
      // Fetch schools
      const resSchools = await fetch(`${apiUrl.replace(/\/$/, "")}/schools`, {
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      if (!resSchools.ok) throw new Error("Failed to fetch schools");
      const dataSchools = await resSchools.json();
      setSchools(dataSchools.schools || []);
      // Fetch students
      const resStudents = await fetch(`${apiUrl.replace(/\/$/, "")}/students`, {
        headers: { Authorization: token ? `Bearer ${token}` : "" },
      });
      if (!resStudents.ok) throw new Error("Failed to fetch students");
      const dataStudents = await resStudents.json();
      setStudents(dataStudents.students || []);
      // Calculate total students
      setTotalStudents((dataStudents.students || []).length);
    } catch (err) {
      setError(err.message || "Error loading schools or students");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSchoolsAndStudents();
  }, []);

  return (
    <div style={{ background: "#f3f4f6", minHeight: "100vh" }}>
      {/* NAVBAR */}
      <nav
        style={{
          background: "linear-gradient(90deg, #23395d 60%, #2d4a7a 100%)",
          color: "#fff",
          padding: "0 0 0 32px",
          display: "flex",
          alignItems: "center",
          height: 64,
          fontWeight: 500,
          fontSize: 18,
          letterSpacing: 0.5,
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        }}
      >
        <span style={{ fontWeight: 700, fontSize: 22, marginRight: 40 }}>
          COUNSELOR NOTES
        </span>
        <button
          type="button"
          style={{
            background: "none",
            border: "none",
            color: "#fff",
            marginRight: 32,
            fontSize: 18,
            cursor: "pointer",
          }}
          onClick={() => navigate("/dashboard")}
        >
          Home
        </button>
        <button
          type="button"
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            textDecoration: "none",
            marginRight: 32,
            font: "inherit",
            cursor: "pointer",
          }}
          onClick={() => navigate("/support-plans")}
        >
          Support Plans
        </button>
        <button
          type="button"
          style={{
            color: "#fff",
            background: "none",
            border: "none",
            textDecoration: "none",
            marginRight: 32,
            font: "inherit",
            cursor: "pointer",
          }}
          onClick={() => navigate("/analysis")}
        >
          Analysis
        </button>
        {/* Removed Reports per request */}
        <span style={{ fontWeight: 700, marginRight: 32 }}>Add Schools</span>
        <button
          onClick={() => {
            localStorage.removeItem("token");
            navigate("/login");
          }}
          style={{
            marginLeft: "auto",
            marginRight: 24,
            background: "#fff",
            color: "#23395d",
            border: "none",
            borderRadius: 6,
            fontWeight: 700,
            fontSize: 16,
            padding: "8px 22px",
            cursor: "pointer",
            boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
          }}
        >
          Log Out
        </button>
      </nav>

      {/* MAIN CONTENT */}
      <div style={{ maxWidth: 900, margin: "0 auto", padding: 32 }}>
        <h1 style={{ fontSize: 32, fontWeight: 600, margin: "32px 0 24px 0" }}>
          Schools Management
        </h1>

        {/* SUMMARY CARDS */}
        <div style={{ display: "flex", gap: 16, marginBottom: 32 }}>
          <div style={summaryCardStyle}>
            <div style={{ fontSize: 36 }}>🏫</div>
            <div style={{ fontSize: 28, fontWeight: 700 }}>
              {loading ? "..." : schools.length}
            </div>
            <div style={{ color: "#334155" }}>Total Schools</div>
          </div>
          <div style={summaryCardStyle}>
            <div style={{ fontSize: 36 }}>👥</div>
            <div style={{ fontSize: 28, fontWeight: 700 }}>
              {loading ? "..." : totalStudents}
            </div>
            <div style={{ color: "#334155" }}>Total Students</div>
          </div>
        </div>

        {/* SEARCH */}
        <div style={{ display: "flex", marginBottom: 8 }}>
          <input
            type="text"
            placeholder="Search by school name, school ID, or location"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              flex: 1,
              padding: 14,
              fontSize: 16,
              borderRadius: 6,
              border: "1px solid #cbd5e1",
              marginRight: 12,
              background: "#fff",
            }}
          />
          <button
            style={{
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              fontSize: 18,
              padding: "12px 32px",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Search
          </button>
        </div>

        {/* TABS + ADD */}
        <div style={{ display: "flex", marginBottom: 0 }}>
          <div style={{ display: "flex", gap: 24 }}>
            <span
              style={{
                borderBottom: tab === "table" ? "3px solid #2563eb" : "none",
                color: tab === "table" ? "#2563eb" : "#222",
                cursor: "pointer",
              }}
              onClick={() => setTab("table")}
            >
              Table View
            </span>
            <span
              style={{
                borderBottom: tab === "card" ? "3px solid #2563eb" : "none",
                color: tab === "card" ? "#2563eb" : "#222",
                cursor: "pointer",
              }}
              onClick={() => setTab("card")}
            >
              Card View
            </span>
          </div>
          <button
            style={{
              marginLeft: "auto",
              background: "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 6,
              fontSize: 18,
              padding: "10px 28px",
              fontWeight: 600,
              cursor: "pointer",
            }}
            onClick={() => setShowAddSchool(true)}
          >
            + Add New School
          </button>
        </div>

        {/* ADD SCHOOL MODAL */}
        {showAddSchool && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 10,
                padding: 32,
                minWidth: 400,
                position: "relative",
              }}
            >
              <button
                onClick={() => setShowAddSchool(false)}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  background: "none",
                  border: "none",
                  fontSize: 22,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
              <h2 style={{ marginBottom: 18 }}>Add New School</h2>
              <AddSchoolForm
                onSuccess={() => {
                  setShowAddSchool(false);
                  fetchSchoolsAndStudents();
                }}
              />
            </div>
          </div>
        )}

        {/* TABLE */}
        {tab === "table" && (
          <div
            style={{
              background: "#fff",
              borderRadius: 10,
              marginTop: 18,
              boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
              overflow: "hidden",
            }}
          >
            {loading ? (
              <div style={{ padding: 32, textAlign: "center" }}>
                Loading schools...
              </div>
            ) : error ? (
              <div
                style={{ padding: 32, textAlign: "center", color: "#ef4444" }}
              >
                {error}
              </div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead style={{ background: "#f1f5f9" }}>
                  <tr>
                    <th style={{ padding: 16, textAlign: "left" }}>
                      School Name
                    </th>
                    <th style={{ padding: 16, textAlign: "left" }}>
                      School ID
                    </th>
                    <th style={{ padding: 16, textAlign: "left" }}>Location</th>
                    <th style={{ padding: 16, textAlign: "left" }}>Students</th>
                  </tr>
                </thead>
                <tbody>
                  {schools.length === 0 ? (
                    <tr>
                      <td
                        colSpan={4}
                        style={{ padding: 32, textAlign: "center" }}
                      >
                        No schools found.
                      </td>
                    </tr>
                  ) : (
                    schools.map((s, i) => (
                      <tr
                        key={i}
                        style={{
                          borderTop: i === 0 ? "none" : "1px solid #e5e7eb",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedSchool(s)}
                      >
                        <td style={{ padding: 16 }}>{s.name}</td>
                        <td style={{ padding: 16 }}>{s.schoolCode}</td>
                        <td style={{ padding: 16 }}>{s.address}</td>
                        <td style={{ padding: 16 }}>
                          {
                            students.filter(
                              (stu) => stu.schoolCode === s.schoolCode
                            ).length
                          }
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
          </div>
        )}

        {/* SCHOOL MODAL */}
        {selectedSchool && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 2000,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 10,
                padding: 32,
                minWidth: 400,
                position: "relative",
              }}
            >
              <button
                onClick={() => setSelectedSchool(null)}
                style={{
                  position: "absolute",
                  top: 12,
                  right: 12,
                  background: "none",
                  border: "none",
                  fontSize: 22,
                  cursor: "pointer",
                }}
              >
                ×
              </button>
              <h2>{selectedSchool.name}</h2>
              <div>
                <b>School ID:</b> {selectedSchool.schoolCode}
              </div>
              <div>
                <b>Location:</b> {selectedSchool.address}
              </div>
              <div>
                <b>Students:</b> {selectedSchool.studentCount || 0}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AddSchools;

// AddSchoolForm component
function AddSchoolForm({ onSuccess }) {
  const [name, setName] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const apiUrl = process.env.REACT_APP_API_URL || "";
      const res = await fetch(`${apiUrl.replace(/\/$/, "")}/schools`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify({ name, address }),
      });
      if (!res.ok) throw new Error("Failed to add school");
      onSuccess();
    } catch (err) {
      setError(err.message || "Error adding school");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: 14 }}>
        <label style={{ display: "block", fontWeight: 500, marginBottom: 6 }}>
          School Name
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          style={{
            width: "100%",
            padding: 10,
            borderRadius: 6,
            border: "1px solid #cbd5e1",
          }}
        />
      </div>
      <div style={{ marginBottom: 18 }}>
        <label style={{ display: "block", fontWeight: 500, marginBottom: 6 }}>
          Location
        </label>
        <input
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          required
          style={{
            width: "100%",
            padding: 10,
            borderRadius: 6,
            border: "1px solid #cbd5e1",
          }}
        />
      </div>
      {error && (
        <div style={{ color: "#ef4444", marginBottom: 10 }}>{error}</div>
      )}
      <button
        type="submit"
        disabled={loading}
        style={{
          background: loading ? "#a5b4fc" : "#2563eb",
          color: "#fff",
          border: "none",
          borderRadius: 6,
          fontSize: 17,
          padding: "10px 24px",
          fontWeight: 600,
          cursor: loading ? "not-allowed" : "pointer",
        }}
      >
        {loading ? "Adding..." : "Add School"}
      </button>
    </form>
  );
}
